module.exports = __webpack_public_path__ + "default_logo.bb90d64a28a3b80f03d419e8fff374bb.png";